import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { AdAccountsSelectionPopup } from './AdAccountsSelectionPopup';

export const AD_ACCOUNTS_SELECTION_POPUP = Symbol('AD_ACCOUNTS_SELECTION');

export const useAdAccountsSelectionPopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(AD_ACCOUNTS_SELECTION_POPUP, AdAccountsSelectionPopup);
  });

  return useCallback(
    ({
      channel,
      brandVoiceId,
      customModel,
      isTrainingModel,
      onConnectSuccess,
      displayConnectedAccounts,
    }) => {
      return new Promise((resolve) => {
        popups.openPopup(AD_ACCOUNTS_SELECTION_POPUP, {
          channel,
          brandVoiceId,
          customModel,
          isTrainingModel,
          onConnectSuccess,
          displayConnectedAccounts,
          onClose: () => {
            popups.closePopup(AD_ACCOUNTS_SELECTION_POPUP);
            resolve();
          },
        });
      });
    },
    [popups]
  );
};
